import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { WVBase, WVMain } from '../wallboard-view.model';
import { MarketplaceSetupObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-marketplace',
    templateUrl: './wallboard-view-marketplace.component.html',
    styleUrls: ['./wallboard-view-marketplace.component.scss']
})
export class WallboardViewMarketplaceComponent implements OnInit, OnDestroy {
    @Input() firstSlide: boolean;

    public wvf: WVMain;
    public wvmf: WVBase;
    public marketplaceState: MarketplaceSetupObj;
    public products: string[] = [];

    public isLoading: boolean;
    public pageSize: number = 0;
    public totalPages: number = 0;
    public currentPage: number = 0;
    private $viewContainer: JQuery<HTMLElement>;
    public setBackground: string = "";
    public index: number = 0;
    private localization: Map<string, string>;

    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";
    private _backgroundID: number = 0;
    

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    get backgroundID(): number {
        return this._backgroundID;
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvmf = this.service.WVMarketplace;
        this.isLoading = true;
        this._hasBackdrop = this.wvmf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvmf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
        this._backgroundID = this.wvmf?.Slide.BackgroundImageID ?? 0;

        this.cvLocalizationService.GetSection("MarketPlace_Management").then(response => {
            this.localization = response;
        });

        this.wallboardsService.loadTypeState(ModuleType.Marketplace, this.moduleKey, this.wvf.WallboardCreatorID).then(response => {
            if (this.isDestroyed)
                return;

            this.marketplaceState = response.Marketplace_Setup;

            this.wallboardsService.loadPointStoreProducts(this.moduleKey, this.wvf.WallboardCreatorID, this.marketplaceState.ProductList).then(response => {
                if (this.isDestroyed)
                    return;

                this.products = response;

                this.wvf.RunSlide = this.firstSlide;

                this.$viewContainer = angular.element(document).find('.wallboardViewSlide');
                this.$viewContainer.height('100vh');
                //this.setBackground = this.wvf.setBackground();
                this.isLoading = false;

                this.runSlide();
            });
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    async runSlide() {
        let calculatedInterval = null;
        let slideIntervalTime;
        // Verifies that the slide is not the first one
        let verifyNextSlide = this.firstSlide == undefined && (this.wvmf.Slide.WallboardModuleDetails[0].WallboardSlideID == this.wvf.Slides[this.wvf.NextSlide].WallboardSlideID);

        if (verifyNextSlide)
            slideIntervalTime = (this.wvf.Slides[this.wvf.NextSlide].SlideInterval - 1) * 1000;
        else
            slideIntervalTime = (this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval - 1) * 1000;

        // Pagination logic
        this.pageSize = this.marketplaceState.DisplayOption;

        if (this.products.length > this.pageSize) {
            this.totalPages = Math.ceil(this.products.length / this.pageSize);
            calculatedInterval = ((slideIntervalTime - 1000) / this.totalPages);

            // Agreed on a minimum of 3 seconds per page
            if (calculatedInterval < 3000) {
                calculatedInterval = 3000;
                slideIntervalTime = calculatedInterval * this.totalPages;

                this.service.calculatePagination(calculatedInterval, slideIntervalTime, this.totalPages, verifyNextSlide);
            }
        }
        else
            this.currentPage = 0;

        if (this.firstSlide)
            this.wvf.FirstSlideReady = true;
        else
            this.wvf.NextSlideReady = true;

        if (this.wvf.RunSlide) {
            if (calculatedInterval != null && this.totalPages > 0) {
                for (let i = 0; i < this.totalPages; i++) {
                    setTimeout(() => {
                        this.currentPage = this.service.runPagination(this.index, this.currentPage);
                        this.index++;
                    }, i * calculatedInterval, true, i);
                }
            }
        }
        else {
            setTimeout(() => {
                this.runSlide();
            }, 1000);
        }
    }

    getDateString(EndDate) {
        if (EndDate == "")
            return this.localization?.get("Always_Available");

        let date1 = new Date();
        date1.setHours(0, 0, 0, 0);
        let date2 = new Date(EndDate);

        if (date1.getTime() == date2.getTime())
            return this.localization?.get("Available_Until") + " " + this.localization?.get("Today").toLowerCase();
        else
            return this.localization?.get("Available_Until") + " " + EndDate;
    }

    getSaleDate(SaleDate): string {
        let date1: Date = new Date();
        date1.setHours(0, 0, 0, 0);
        let date2: Date = new Date(SaleDate);

        if (date1.getTime() == date2.getTime())
            return this.localization?.get("Off_Until") + " " + this.localization?.get("Today").toLowerCase();
        else
            return this.localization?.get("Off_Until") + " " + date2.toDateString();
    }

    getSalePrice(prod) {
        return Math.ceil(prod.Price - (prod.Price * prod.Sale / 100));
    }

    getVariationPrices(prod) {
        let initialVariationPrice = 0;
        let initialVariation = prod.VariationsData.reduce(function (prev, curr) {
            let prevValue = prev.VariationPrice;
            let currValue = curr.VariationPrice;

            if (prev.VariationOnSale)
                prevValue = prev.VariationPrice - (prev.VariationPrice * (prod.Sale / 100));

            if (curr.VariationOnSale)
                currValue = curr.VariationPrice - (curr.VariationPrice * (prod.Sale / 100));

            return prevValue < currValue ? prev : curr;
        });

        if (initialVariation.VariationOnSale)
            initialVariationPrice = Math.ceil(initialVariation.VariationPrice - ((prod.Sale / 100.0) * initialVariation.VariationPrice))
        else
            initialVariationPrice = initialVariation.VariationPrice;

        let lastVariationPrice = 0;
        let lastVariation = prod.VariationsData.reduce(function (prev, curr) {
            let prevValue = prev.VariationPrice;
            let currValue = curr.VariationPrice;

            if (prev.VariationOnSale)
                prevValue = prev.VariationPrice - (prev.VariationPrice * (prod.Sale / 100));

            if (curr.VariationOnSale)
                currValue = curr.VariationPrice - (curr.VariationPrice * (prod.Sale / 100));

            return prevValue > currValue ? prev : curr;
        });

        if (lastVariation.VariationOnSale)
            lastVariationPrice = Math.ceil(lastVariation.VariationPrice - ((prod.Sale / 100.0) * lastVariation.VariationPrice))
        else
            lastVariationPrice = lastVariation.VariationPrice;

        return this.NumberLocalize(initialVariationPrice, false) + " - " + this.NumberLocalize(lastVariationPrice, false);
    }

    isCurrentSale(item) {
        let currentDate: Date = new Date();
        currentDate.setHours(0, 0, 0, 0);
        let filterMatch = false;

        let dateStart: Date = item.SaleStart != null ?  new Date(item.SaleStart): null;
        let dateEnd: Date = item.SaleEnd != null ?  new Date(item.SaleEnd): null;

        if (dateStart != null && dateStart.toString() != "" && dateEnd != null && dateEnd.toString() != "") {
            //dateStart = new Date(dateStart.setHours(0, 0, 0, 0));
           dateStart.setHours(0, 0, 0, 0);
            //dateEnd = new Date(dateEnd.setHours(0, 0, 0, 0));
            dateEnd.setHours(0, 0, 0, 0);

            filterMatch = dateStart <= currentDate && currentDate <= dateEnd;
        }

        if (dateStart != null && dateStart.toString() != "" && (dateEnd == null || dateEnd.toString() == "")) {
            //dateStart = new Date(dateStart.setHours(0, 0, 0, 0));
            dateStart.setHours(0, 0, 0, 0);

            filterMatch = dateStart <= currentDate;
        }

        if ((dateStart == null || dateStart.toString() == "") && (dateEnd == null || dateEnd.toString() == ""))
            filterMatch = false;

        return filterMatch;
    }

    isOutOfStock(product) {
        if (product) {
            if (product.HasProductVariations) {
                let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID });
                return (selectedVariation != null && (selectedVariation.VariationQuantity == 0 || selectedVariation.VariationQuantity < 0))
            }
            else
                return product.Quantity == 0 || product.Quantity < 0;
        }
        else
            return false;
    }

    getPixelSize(value: number) {
        return (window.innerHeight * (value / 100));
    }

    NumberLocalize(input: any, isCurrency: boolean = null): any {
        if (input == 0)
            return 0;
        if (input != 0 && (input == null || input == ''))
            return '';
        if (isNaN(input))
            return input;

        // Set a default value for isCurrency if a value is not given.
        // Can't do this in the parameter definitions, as IE doesn't support default parameters. Not even on a basic level.
        if (isCurrency == null)
            isCurrency = false;

        // Initial split on decimal
        let decimalSplit = input.toString().split('.');

        // Format helper vars
        let threeCount = 0;
        let wholeFormat = [];

        let symbolGroupNumber = CVNumberGroupingSymbol,
            symbolGroupCurrency = CVCurrencyGroupingSymbol,
            symbolDecimal = CVDecimalSymbol;

        // Do the format
        decimalSplit[0].split('').reverse().forEach(function (c) {
            threeCount += 1;
            wholeFormat.push(c);

            if (threeCount >= 3) {
                threeCount = 0;

                if (isCurrency)
                    wholeFormat.push(symbolGroupCurrency);
                else
                    wholeFormat.push(symbolGroupNumber);
            }
        });

        // Check for dangling group symbols (',123.01' => '123.01')
        if (wholeFormat[wholeFormat.length - 1] == symbolGroupNumber || wholeFormat[wholeFormat.length - 1] == symbolGroupCurrency)
            wholeFormat.pop();

        // Final touches
        let result = wholeFormat.reverse().join('');
        if (decimalSplit[1] != null)
            result = ''.concat(result, symbolDecimal, decimalSplit[1]);

        return result;
    }
}
